import useWebInstance from "grandus-lib/hooks/useWebInstance";
import { get, parseInt, toNumber } from "lodash";
import Image from "next/image";

const Quatro = ({ price }) => {
  const { settings } = useWebInstance();
  if (
    !(
      price &&
      parseInt(get(settings, "quatro_active")) &&
      get(settings, "quatro_id")
    )
  ) {
    return "";
  }

  if (
    !(
      price > toNumber(get(settings, "quatro_available_from_price", 0)) &&
      price < toNumber(get(settings, "quatro_available_to_price", Infinity))
    )
  ) {
    return "";
  }
  return (
    <div style={{ margin: "15px 25px 0 25px", textAlign: "right" }}>
      <a
        rel="nofollow"
        target="_blank"
        href={`https://quatro.vub.sk/kalkulacka/${get(
          settings,
          "quatro_id"
        )}?cenaTovaru=${price}`}
      >
        <Image src="/quatro-calc.png" height="30" width="141" />
      </a>
    </div>
  );
};

export default Quatro;
